import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "unlock",
  "use": "unlock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"unlock\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M20 20c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-7c0-.5.5-1 1-1h14c.6 0 1 .5 1 1v7zm-1-10H8V7a4 4 0 018-.8 1 1 0 101.9-.4A6 6 0 006 7v3H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol